import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.698 8.939l3.802 2.195v-4.39L8.54 4.43a.5.5 0 0 1 .616-.788L11.5 5.475V1.5a.5.5 0 1 1 1 0v3.975l2.344-1.832a.5.5 0 0 1 .616.788L12.5 6.744v4.39l3.802-2.195.523-3.72a.5.5 0 0 1 .99.14l-.414 2.945 3.442-1.987a.5.5 0 1 1 .5.866L17.901 9.17l2.758 1.115a.5.5 0 0 1-.374.927l-3.483-1.407L13 12l3.802 2.195 3.483-1.407a.5.5 0 1 1 .374.927l-2.758 1.115 3.442 1.987a.5.5 0 1 1-.5.866l-3.442-1.987.414 2.945a.5.5 0 0 1-.99.14l-.523-3.72-3.802-2.195v4.39l2.96 2.313a.5.5 0 0 1-.616.788L12.5 18.525V22.5a.5.5 0 1 1-1 0v-3.975l-2.344 1.832a.5.5 0 0 1-.616-.788l2.96-2.313v-4.39l-3.802 2.195-.523 3.72a.5.5 0 1 1-.99-.14l.414-2.945-3.442 1.987a.5.5 0 1 1-.5-.866l3.442-1.987-2.758-1.115a.5.5 0 0 1 .374-.927l3.483 1.407L11 12 7.198 9.805l-3.483 1.407a.5.5 0 1 1-.374-.927L6.099 9.17 2.657 7.183a.5.5 0 1 1 .5-.866l3.442 1.987-.414-2.945a.5.5 0 0 1 .99-.14l.523 3.72z"
});

var SvgCold = function SvgCold(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCold;